export default __webpack_public_path__ + "static/8-f84fd5cdabec7a59db960cb780461342.png";